module.exports = __webpack_public_path__ + "img/approve-list13.754e00ed.png";